export default __webpack_public_path__ + "static/media/back-icon.2eac155c.svg";